export const TOGGLE_DESTROY_MODAL = 'TOGGLE_DESTROY_MODAL';

export function toggleDestroyModal(objectIdToDestroy = '', objectNameToDestroy = '') {
  return {
    type: TOGGLE_DESTROY_MODAL,
    payload: {
      objectIdToDestroy,
      objectNameToDestroy,
    },
  };
}
